import gql from 'graphql-tag'

export default gql`
  query getAllCategories {
    getAllCategories {
      id
      name
      img_url
      url_key
      type
    }
  }
`
